import { render, staticRenderFns } from "./FeesNewDialogButton.vue?vue&type=template&id=60564d32"
import script from "./FeesNewDialogButton.vue?vue&type=script&lang=js"
export * from "./FeesNewDialogButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports